// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  border-radius: 0;
  position: fixed;
  z-index: 1030;
  top: 0;
  padding-top: 56px;
  left: 235px;
  width: 235px;
  margin-left: -235px;
  margin-bottom: 48px;
  border: none;
  border-radius: 0;
  overflow-y: auto;
  background-color: #000;
  bottom: 0;
  overflow-x: hidden;
  padding-bottom: 40px;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
}
.sidebar .list-group a.list-group-item {
  background: #000;
  border: 0;
  border-radius: 0;
  color: #999;
  text-decoration: none;
}
.sidebar .list-group a.list-group-item .fa {
  margin-right: 10px;
}
.sidebar .list-group a:hover {
  background: black;
  color: #fff;
}
.sidebar .list-group a.router-link-active {
  background: black;
  color: #fff;
}
.sidebar .list-group .header-fields {
  padding-top: 10px;
}
.sidebar .list-group .header-fields > .list-group-item:first-child {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .sidebar-dropdown *:focus {
  border-radius: none;
  border: none;
}
.sidebar .sidebar-dropdown .panel-title {
  font-size: 1rem;
  height: 50px;
  margin-bottom: 0;
}
.sidebar .sidebar-dropdown .panel-title a {
  color: #999;
  text-decoration: none;
  font-weight: 400;
  background: #000;
}
.sidebar .sidebar-dropdown .panel-title a span {
  position: relative;
  display: block;
  padding: 0.75rem 1.5rem;
  padding-top: 1rem;
}
.sidebar .sidebar-dropdown .panel-title a:hover,
.sidebar .sidebar-dropdown .panel-title a:focus {
  color: #fff;
  outline: none;
  outline-offset: -2px;
}
.sidebar .sidebar-dropdown .panel-title:hover {
  background: black;
}
.sidebar .sidebar-dropdown .panel-collapse {
  border-radious: 0;
  border: none;
}
.sidebar .sidebar-dropdown .panel-collapse .panel-body .list-group-item {
  border-radius: 0;
  background-color: #000;
  border: 0 solid transparent;
}
.sidebar .sidebar-dropdown .panel-collapse .panel-body .list-group-item a {
  color: #999;
}
.sidebar .sidebar-dropdown .panel-collapse .panel-body .list-group-item a:hover {
  color: #fff;
}
.sidebar .sidebar-dropdown .panel-collapse .panel-body .list-group-item:hover {
  background: black;
}

.nested-menu .list-group-item {
  cursor: pointer;
}
.nested-menu .nested {
  list-style-type: none;
}
.nested-menu ul.submenu {
  display: none;
  height: 0;
}
.nested-menu .expand ul.submenu {
  display: block;
  list-style-type: none;
  height: auto;
}
.nested-menu .expand ul.submenu li a {
  color: #fff;
  padding: 10px;
  display: block;
}

@media screen and (max-width: 992px) {
  .sidebar {
    top: 54px;
    left: 0px;
  }
}
@media print {
  .sidebar {
    display: none !important;
  }
}
@media (min-width: 992px) {
  .header-fields {
    display: none;
  }
}
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px rgb(255, 255, 255);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  -webkit-box-shadow: inset 0 0 3px rgb(255, 255, 255);
}

.toggle-button {
  position: fixed;
  width: 236px;
  cursor: pointer;
  padding: 12px;
  bottom: 0;
  color: #999;
  background: #212529;
  border-top: 1px solid #999;
  transition: all 0.2s ease-in-out;
}
.toggle-button i {
  font-size: 23px;
}
.toggle-button:hover {
  background: black;
  color: #fff;
}

.collapsed {
  width: 60px;
}
.collapsed span {
  display: none;
}

.SB-Btn-group {
  display: flex;
  justify-content: start;
}
.SB-Btn-group .SBbtnIconExit {
  padding: 0 5px;
  cursor: pointer;
  color: #808b9c;
}
.SB-Btn-group .SBbtnIcon {
  padding: 0 5px;
  cursor: pointer;
  color: #808b9c;
}
.SB-Btn-group .SBbtnIcon:hover {
  color: #fff;
  background-color: #1873ad;
}
.SB-Btn-group .SBbtnIconExit:hover {
  color: #fff;
  background-color: #d2322d;
}

.SB-logo {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/layoutComponent/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAduB;EAevB,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EAKA,gCAAA;AADJ;AAIQ;EACI,gBA3Be;EA4Bf,SAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AAFZ;AAIY;EACI,kBAAA;AAFhB;AAMQ;EACI,iBAAA;EACA,WAAA;AAJZ;AAOQ;EACI,iBAAA;EACA,WAAA;AALZ;AAQQ;EACI,iBAAA;AANZ;AAQY;EACI,8CAAA;AANhB;AAYQ;EACI,mBAAA;EACA,YAAA;AAVZ;AAaQ;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAXZ;AAaY;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAxEW;AA6D3B;AAagB;EACI,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAXpB;AAeY;;EAEI,WAAA;EACA,aAAA;EACA,oBAAA;AAbhB;AAiBQ;EACI,iBAAA;AAfZ;AAkBQ;EACI,iBAAA;EACA,YAAA;AAhBZ;AAmBgB;EACI,gBAAA;EACA,sBArGO;EAsGP,2BAAA;AAjBpB;AAmBoB;EACI,WAAA;AAjBxB;AAoBoB;EACI,WAAA;AAlBxB;AAsBgB;EACI,iBAAA;AApBpB;;AA4BI;EACI,eAAA;AAzBR;AA4BI;EACI,qBAAA;AA1BR;AA6BI;EACI,aAAA;EACA,SAAA;AA3BR;AA+BQ;EACI,cAAA;EACA,qBAAA;EACA,YAAA;AA7BZ;AAgCgB;EACI,WAAA;EACA,aAAA;EACA,cAAA;AA9BpB;;AAqCA;EACI;IACI,SAAA;IACA,SAAA;EAlCN;AACF;AAqCA;EACI;IACI,wBAAA;EAnCN;AACF;AAsCA;EACI;IACI,aAAA;EApCN;AACF;AAuCA;EACI,UAAA;AArCJ;;AAwCA;EACI,oDAAA;EACA,kBAAA;AArCJ;;AAwCA;EACI,kBAAA;EACA,oDAAA;AArCJ;;AAwCA;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EAWA,0BAAA;EAKA,gCAAA;AA/CJ;AAiCI;EACI,eAAA;AA/BR;AAkCI;EACI,iBAAA;EACA,WAAA;AAhCR;;AA2CA;EACI,WAAA;AAxCJ;AA0CI;EACI,aAAA;AAxCR;;AA2CA;EACI,aAAA;EACA,sBAAA;AAxCJ;AAyCI;EACI,cAAA;EACA,eAAA;EACA,cAAA;AAvCR;AA0CI;EACI,cAAA;EACA,eAAA;EACA,cAAA;AAxCR;AA2CM;EACE,WAAA;EACA,yBAAA;AAzCR;AA6CM;EACE,WAAA;EACA,yBAAA;AA3CR;;AAgDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA7CJ","sourcesContent":["$topnav-background-color: #3ac2a8;\r\n$sidebar-background-color: #000;\r\n.sidebar {\r\n    border-radius: 0;\r\n    position: fixed;\r\n    z-index: 1030;\r\n    top: 0;\r\n    padding-top: 56px;\r\n    left: 235px;\r\n    width: 235px;\r\n    margin-left: -235px;\r\n    margin-bottom: 48px;\r\n    border: none;\r\n    border-radius: 0;\r\n    overflow-y: auto;\r\n    background-color: $sidebar-background-color;\r\n    bottom: 0;\r\n    overflow-x: hidden;\r\n    padding-bottom: 40px;\r\n    white-space: nowrap;\r\n    -webkit-transition: all 0.2s ease-in-out;\r\n    -moz-transition: all 0.2s ease-in-out;\r\n    -ms-transition: all 0.2s ease-in-out;\r\n    -o-transition: all 0.2s ease-in-out;\r\n    transition: all 0.2s ease-in-out;\r\n    // border-top: 1px solid rgba(255,255,255,0.3);\r\n    .list-group {\r\n        a.list-group-item {\r\n            background: $sidebar-background-color;\r\n            border: 0;\r\n            border-radius: 0;\r\n            color: #999;\r\n            text-decoration: none;\r\n\r\n            .fa {\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n\r\n        a:hover {\r\n            background: darken($sidebar-background-color, 5%);\r\n            color: #fff;\r\n        }\r\n\r\n        a.router-link-active {\r\n            background: darken($sidebar-background-color, 5%);\r\n            color: #fff;\r\n        }\r\n\r\n        .header-fields {\r\n            padding-top: 10px;\r\n\r\n            > .list-group-item:first-child {\r\n                border-top: 1px solid rgba(255, 255, 255, 0.2);\r\n            }\r\n        }\r\n    }\r\n\r\n    .sidebar-dropdown {\r\n        *:focus {\r\n            border-radius: none;\r\n            border: none;\r\n        }\r\n\r\n        .panel-title {\r\n            font-size: 1rem;\r\n            height: 50px;\r\n            margin-bottom: 0;\r\n\r\n            a {\r\n                color: #999;\r\n                text-decoration: none;\r\n                font-weight: 400;\r\n                background: $sidebar-background-color;\r\n\r\n                span {\r\n                    position: relative;\r\n                    display: block;\r\n                    padding: 0.75rem 1.5rem;\r\n                    padding-top: 1rem;\r\n                }\r\n            }\r\n\r\n            a:hover,\r\n            a:focus {\r\n                color: #fff;\r\n                outline: none;\r\n                outline-offset: -2px;\r\n            }\r\n        }\r\n\r\n        .panel-title:hover {\r\n            background: darken($sidebar-background-color, 5%);\r\n        }\r\n\r\n        .panel-collapse {\r\n            border-radious: 0;\r\n            border: none;\r\n\r\n            .panel-body {\r\n                .list-group-item {\r\n                    border-radius: 0;\r\n                    background-color: $sidebar-background-color;\r\n                    border: 0 solid transparent;\r\n\r\n                    a {\r\n                        color: #999;\r\n                    }\r\n\r\n                    a:hover {\r\n                        color: #fff;\r\n                    }\r\n                }\r\n\r\n                .list-group-item:hover {\r\n                    background: darken($sidebar-background-color, 5%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.nested-menu {\r\n    .list-group-item {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .nested {\r\n        list-style-type: none;\r\n    }\r\n\r\n    ul.submenu {\r\n        display: none;\r\n        height: 0;\r\n    }\r\n\r\n    & .expand {\r\n        ul.submenu {\r\n            display: block;\r\n            list-style-type: none;\r\n            height: auto;\r\n\r\n            li {\r\n                a {\r\n                    color: #fff;\r\n                    padding: 10px;\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n    .sidebar {\r\n        top: 54px;\r\n        left: 0px;\r\n    }\r\n}\r\n\r\n@media print {\r\n    .sidebar {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .header-fields {\r\n        display: none;\r\n    }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 0px rgba(255, 255, 255, 1);\r\n    border-radius: 3px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    border-radius: 3px;\r\n    -webkit-box-shadow: inset 0 0 3px rgba(255, 255, 255, 1);\r\n}\r\n\r\n.toggle-button {\r\n    position: fixed;\r\n    width: 236px;\r\n    cursor: pointer;\r\n    padding: 12px;\r\n    bottom: 0;\r\n    color: #999;\r\n    background: #212529;\r\n\r\n    i {\r\n        font-size: 23px;\r\n    }\r\n\r\n    &:hover {\r\n        background: darken($sidebar-background-color, 5%);\r\n        color: #fff;\r\n    }\r\n\r\n    border-top: 1px solid #999;\r\n    -webkit-transition: all 0.2s ease-in-out;\r\n    -moz-transition: all 0.2s ease-in-out;\r\n    -ms-transition: all 0.2s ease-in-out;\r\n    -o-transition: all 0.2s ease-in-out;\r\n    transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.collapsed {\r\n    width: 60px;\r\n\r\n    span {\r\n        display: none;\r\n    }\r\n}\r\n.SB-Btn-group{\r\n    display: flex;\r\n    justify-content: start;\r\n    .SBbtnIconExit{\r\n        padding: 0 5px ;\r\n        cursor: pointer;\r\n        color: #808b9c;\r\n\r\n    }\r\n    .SBbtnIcon{\r\n        padding: 0 5px ;\r\n        cursor: pointer;\r\n        color: #808b9c;\r\n\r\n      }\r\n      .SBbtnIcon:hover{\r\n        color: #fff;\r\n        background-color: #1873ad;\r\n\r\n\r\n      }\r\n      .SBbtnIconExit:hover{\r\n        color: #fff;\r\n        background-color: #d2322d;\r\n\r\n\r\n    }\r\n}\r\n.SB-logo{\r\n    width:54px ; \r\n    height: 54px;\r\n    border-radius: 50%;\r\n    margin: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
